import React, { useState, useRef, useCallback } from "react";
import { QrReader } from "react-qr-reader";
import { useDispatch } from "react-redux";
import { useHistory } from "react-router-dom";
import { verifyQr } from "../../actions/invoiceActions";
import {
  Button,
  Typography,
  Card,
  CardContent,
  Box,
  IconButton,
  Container,
  CircularProgress,
  Fade,
  Slide,
  Dialog,
  DialogContent,
  Zoom,
} from "@material-ui/core";
import {
  CameraAlt,
  CheckCircle,
  Error,
  Warning,
  CropFree,
  Close,
} from "@material-ui/icons";
import ExitToAppIcon from "@material-ui/icons/ExitToApp";
import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
  root: {
    minHeight: "85vh",
    background: "linear-gradient(135deg, #1e3c72 0%, #2a5298 100%)",
    padding: theme.spacing(2),
  },
  headerCard: {
    background: "linear-gradient(45deg, #2196F3 30%, #21CBF3 90%)",
    color: "white",
    textAlign: "center",
    marginBottom: theme.spacing(3),
    borderRadius: theme.spacing(2),
    boxShadow: "0 4px 20px rgba(0, 0, 0, 0.2)",
  },
  scannerCard: {
    borderRadius: theme.spacing(2),
    marginBottom: theme.spacing(2),
    background: "rgba(255, 255, 255, 0.95)",
    backdropFilter: "blur(10px)",
    boxShadow: "0 4px 30px rgba(0, 0, 0, 0.1)",
  },
  modeButton: {
    height: 60,
    marginBottom: theme.spacing(2),
    borderRadius: theme.spacing(1.5),
    fontSize: "1.1rem",
    fontWeight: 600,
    background: "linear-gradient(45deg, #2196F3 30%, #21CBF3 90%)",
    color: "white",
    "&:hover": {
      background: "linear-gradient(45deg, #1976D2 30%, #1E88E5 90%)",
    },
  },
  scannerContainer: {
    position: "relative",
    borderRadius: theme.spacing(1),
    overflow: "hidden",
    background: "#000",
  },
  scannerOverlay: {
    position: "absolute",
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    pointerEvents: "none",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  scannerFrame: {
    position: "absolute",
    top: 20,
    left: 20,
    right: 20,
    bottom: 20,
    border: "2px solid rgba(255, 255, 255, 0.3)",
    borderRadius: theme.spacing(1),
    "&::before, &::after": {
      content: '""',
      position: "absolute",
      width: 30,
      height: 30,
    },
    "&::before": {
      top: -2,
      left: -2,
      borderTop: "4px solid #2196F3",
      borderLeft: "4px solid #2196F3",
    },
    "&::after": {
      bottom: -2,
      right: -2,
      borderBottom: "4px solid #2196F3",
      borderRight: "4px solid #2196F3",
    },
  },
  processingOverlay: {
    background: "rgba(33, 150, 243, 0.8)",
    color: "white",
    padding: theme.spacing(2),
    borderRadius: theme.spacing(1),
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    gap: theme.spacing(1),
    width: "100%",
    height: "100%",
  },
  dialog: {
    borderRadius: theme.spacing(2),
    background: "linear-gradient(135deg, #ffffff 0%, #f5f7fa 100%)",
    boxShadow: "0 8px 40px rgba(0, 0, 0, 0.2)",
    overflow: "hidden",
  },
  dialogContent: {
    padding: theme.spacing(4),
    textAlign: "center",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    gap: theme.spacing(2),
  },
  successIcon: {
    fontSize: 60,
    color: "#4CAF50",
    animation: "$pulse 1.5s infinite",
  },
  errorIcon: {
    fontSize: 60,
    color: "#F44336",
    animation: "$shake 0.5s",
  },
  warningIcon: {
    fontSize: 60,
    color: "#FF9800",
    animation: "$shake 0.5s",
  },
  "@keyframes pulse": {
    "0%": { transform: "scale(1)" },
    "50%": { transform: "scale(1.2)" },
    "100%": { transform: "scale(1)" },
  },
  "@keyframes shake": {
    "0%, 100%": { transform: "translateX(0)" },
    "25%": { transform: "translateX(-5px)" },
    "75%": { transform: "translateX(5px)" },
  },
  dialogMessage: {
    fontWeight: 500,
    fontSize: "1.2rem",
    color: theme.palette.text.primary,
  },
  codeText: {
    fontFamily: "monospace",
    fontSize: "0.9rem",
    wordBreak: "break-all",
    background: "rgba(0, 0, 0, 0.05)",
    padding: theme.spacing(1),
    borderRadius: theme.spacing(1),
    marginTop: theme.spacing(1),
  },
}));

const QrScanner = () => {
  const classes = useStyles();
  const [result, setResult] = useState("");
  const [isScanning, setIsScanning] = useState(false);
  const [isCameraOpen, setIsCameraOpen] = useState(false);
  const [dialog, setDialog] = useState({
    open: false,
    message: "",
    severity: "success",
    seatNumbers: [],
    tripNumber: "",
    tripDate: "",
  });
  const dispatch = useDispatch();
  const history = useHistory();
  const lastScanTime = useRef(0);
  const dialogTimeoutRef = useRef(null);

  const lastScannedStationOrder = useRef(0);

const profile = JSON.parse(localStorage.getItem("profile"));
const staffId = profile?.result?.id;


  // const handleScan = useCallback(
  //   (data) => {
  //     const now = Date.now();
  //     if (data && !isScanning && now - lastScanTime.current > 2000) {
  //       lastScanTime.current = now;
  //       setResult(data);
  //       setIsScanning(true);

  //       dispatch(
  //         verifyQr(data, (res) => {
  //           setIsScanning(false);
  //           setIsCameraOpen(false); // Turn off camera when dialog appears
  //           let severity = "success";
  //           let message = "";

  //           if (res.error) {
  //             severity = "error";
  //             message = res.error;
  //           } else if (res.expired) {
  //             severity = "warning";
  //             message = "Ticket expired!";
  //           } else {
  //             severity = "success";
  //             message = `Ticket valid. Scan count: ${res.scanCount}/3`;
  //           }

  //           setDialog({
  //             open: true,
  //             message,
  //             severity,
  //             seatNumbers: res.seatNumbers || [],
  //             tripNumber: res.tripNumber || "",
  //             tripDate: res.tripDate
  //               ? new Date(res.tripDate).toLocaleDateString()
  //               : "",
  //           });

  //           // REMOVE the auto-close setTimeout here!
  //         })
  //       );
  //     }
  //   },
  //   [dispatch, isScanning]
  // );

  // const handleScan = async (scannedText) => {
  //   if (!scannedText || isScanning) return;
  
  //   setIsScanning(true);
  
  //   try {
  //     // 🔥 Normalize scanned value to token
  //     let qrToken = scannedText.trim();
  
  //     // If QR contains URL or file path
  //     if (qrToken.includes("/")) {
  //       qrToken = qrToken.split("/").pop(); // qr_xxx.png
  //       qrToken = qrToken.replace("qr_", "").replace(".png", "");
  //     }
  
  //     console.log("FINAL QR TOKEN:", qrToken);
  
  //     const response = await verifyQr(qrToken);
  
  //     setDialog({
  //       open: true,
  //       severity: "success",
  //       message: response.message || "QR scanned successfully",
  //       seatNumbers: response.seatNumbers || [],
  //       tripDate: response.tripDate || "",
  //     });
  
  //   } catch (err) {
  //     setDialog({
  //       open: true,
  //       severity: "error",
  //       message: err.response?.data?.message || "Invalid QR code",
  //     });
  //   } finally {
  //     setIsScanning(false);
  //   }
  // };

  // Praveen Old Code you can scan any station qr code in any order only one time
  
  // const handleScan = useCallback(
  //   (data) => {
  //     const now = Date.now();
  //     if (!data || isScanning || now - lastScanTime.current < 2000) return;
  
  //     lastScanTime.current = now;
  
  //     // Process scanned QR token
  //     let qrToken = data.trim();
  
  //     // If scanned text is a URL or has qr_ prefix and .png suffix
  //     if (qrToken.includes("/qr/qr_") && qrToken.endsWith(".png")) {
  //       qrToken = qrToken.split("/").pop(); // get last part
  //       qrToken = qrToken.replace("qr_", "").replace(".png", "");
  //     }
  //     // Else assume token is already in correct form
  //     // qrToken remains unchanged
  
  //     setResult(qrToken);
  //     setIsScanning(true);
  
  //     // Dispatch the verifyQr API call
  //     dispatch(
  //       verifyQr(qrToken, (res) => {
  //         setIsScanning(false);
  //         setIsCameraOpen(false); // turn off camera while dialog shows
  
  //         let severity = "success";
  //         let message = "";
  
  //         if (res.error) {
  //           severity = "error";
  //           message = res.error;
  //         } else if (!res.valid) {
  //           severity = "error";
  //           message = res.message || "Invalid or already scanned QR code";
  //         } else {
  //           severity = "success";
  //           message = `QR scanned successfully at ${res.station}`;
  //         }
  
  //         setDialog({
  //           open: true,
  //           message,
  //           severity,
  //           seatNumbers: res.seatNumbers || [],
  //           tripNumber: res.tripNumber || "",
  //           tripDate: res.tripDate
  //             ? new Date(res.tripDate).toLocaleDateString()
  //             : "",
  //         });
  //       })
  //     );
  //   },
  //   [dispatch, isScanning]
  // );
  
   // Praveen Old Code you cannot scan any station qr code in any order first scan station 1 then station 2 then station 3
  
//   const handleScan = useCallback(
//   (data) => {
//     const now = Date.now();
//     if (!data || isScanning || now - lastScanTime.current < 2000) return;

//     lastScanTime.current = now;

//     let qrToken = data.trim();

//     // Normalize token
//     if (qrToken.includes("/qr/qr_") && qrToken.endsWith(".png")) {
//       qrToken = qrToken.split("/").pop();
//       qrToken = qrToken.replace("qr_", "").replace(".png", "");
//     }

//     setResult(qrToken);
//     setIsScanning(true);

//     dispatch(
//       verifyQr(qrToken, staffId, (res) => {
//         setIsScanning(false);

//         let severity = "success";
//         let message = "";

//         // ❌ API error
//         if (res.error) {
//           severity = "error";
//           message = res.error;
//         }
//         // ❌ invalid or reused
//         else if (!res.valid) {
//           severity = "error";
//           message = res.message || "Invalid or already scanned QR code";
//         }
//         // ❌ SEQUENCE BREAK
//         else if (
//           typeof res.stationOrder === "number" &&
//           res.stationOrder !== lastScannedStationOrder.current + 1
//         ) {
//           severity = "error";
//           message = `Please scan Station ${
//             lastScannedStationOrder.current + 1
//           } QR first`;
//         }
//         // ✅ VALID SEQUENCE
//         else {
//           lastScannedStationOrder.current = res.stationOrder;
//           severity = "success";
//           message = `QR scanned successfully at ${res.station}`;
//           setIsCameraOpen(false);
//         }

//         setDialog({
//           open: true,
//           message,
//           severity,
//           seatNumbers: res.seatNumbers || [],
//           tripNumber: res.tripNumber || "",
//           tripDate: res.tripDate
//             ? new Date(res.tripDate).toLocaleDateString()
//             : "",
//         });
//       })
//     );
//   },
//   [dispatch, isScanning]
// );


const handleScan = useCallback(
  (data) => {
    const now = Date.now();
    if (!data || isScanning || now - lastScanTime.current < 2000) return;

    lastScanTime.current = now;

    let qrToken = data.trim();

    // Normalize token
    if (qrToken.includes("/qr/qr_") && qrToken.endsWith(".png")) {
      qrToken = qrToken.split("/").pop();
      qrToken = qrToken.replace("qr_", "").replace(".png", "");
    }

    setResult(qrToken);
    setIsScanning(true);

    dispatch(
      verifyQr(qrToken, staffId, (res) => {
        setIsScanning(false);
        setIsCameraOpen(false); // close camera while showing dialog

        let severity = "success";
        let message = "";

        // ❌ API error
        if (res.error) {
          severity = "error";
          message = res.error;
        }
        // ❌ invalid or reused
        else if (!res.valid) {
          severity = "error";

          // Format scannedAt to local time
          const scannedTime = res.scannedAt
            ? new Date(res.scannedAt).toLocaleString("en-IN", {
                timeZone: "Asia/Kolkata",
                hour12: true,
              })
            : "";

          message =
            res.message && res.scannedAt
              ? `${res.message} at ${scannedTime}`
              : res.message || "Invalid or already scanned QR code";
        }
        // ❌ SEQUENCE BREAK
        else if (
          typeof res.stationOrder === "number" &&
          res.stationOrder !== lastScannedStationOrder.current + 1
        ) {
          severity = "error";
          message = `Please scan Station ${
            lastScannedStationOrder.current + 1
          } QR first`;
        }
        // ✅ VALID SEQUENCE
        else {
          lastScannedStationOrder.current = res.stationOrder;
          severity = "success";
          message = `QR scanned successfully at ${res.station}`;
        }

        setDialog({
          open: true,
          message,
          severity,
          seatNumbers: res.seatNumbers || [],
          tripNumber: res.tripNumber || "",
          tripDate: res.tripDate
            ? new Date(res.tripDate).toLocaleDateString("en-IN", {
                timeZone: "Asia/Kolkata",
              })
            : "",
        });
      })
    );
  },
  [dispatch, isScanning]
);


  
  const handleCloseDialog = () => {
    setDialog({ ...dialog, open: false });
    setIsCameraOpen(true); // Reopen camera when dialog is manually closed
    if (dialogTimeoutRef.current) {
      clearTimeout(dialogTimeoutRef.current);
    }
  };

  const logout = () => {
    dispatch({ type: "LOGOUT" });
    history.push("/");
    window.location.reload();
  };

  const handleCloseCamera = () => {
    setIsCameraOpen(false);
    setResult("");
    setIsScanning(false);
  };

  return (
    <Box className={classes.root}>
      <Container maxWidth="sm">
        {/* Header */}
        <Fade in timeout={1000}>
          <Card className={classes.headerCard}>
            <CardContent>
              <Box
                display="flex"
                justifyContent="space-between"
                alignItems="center"
                mb={2}
              >
                <Box display="flex" alignItems="center">
                  <CropFree style={{ fontSize: 48, marginRight: 8 }} />
                  <Typography variant="h4" component="h1">
                    QR Scanner
                  </Typography>
                </Box>
                <Button
                  variant="contained"
                  color="secondary"
                  startIcon={<ExitToAppIcon />}
                  onClick={logout}
                  style={{ fontWeight: 400, borderRadius: 8 }}
                >
                  Logout
                </Button>
              </Box>
              <Typography variant="body1" style={{ opacity: 0.9 }}>
                Scan QR codes to verify invoices
              </Typography>
            </CardContent>
          </Card>
        </Fade>

        {/* Scanner Interface */}
        <Fade in timeout={600}>
          <Card className={classes.scannerCard}>
            <CardContent>
              <Box
                display="flex"
                justifyContent="space-between"
                alignItems="center"
                mb={2}
              >
                <Typography variant="h6">Camera Scanner</Typography>
                {isCameraOpen && (
                  <IconButton onClick={handleCloseCamera}>
                    <Close />
                  </IconButton>
                )}
              </Box>

              {!isCameraOpen && (
                <Slide direction="up" in timeout={800}>
                  <Box>
                    <Button
                      variant="contained"
                      color="primary"
                      fullWidth
                      className={classes.modeButton}
                      startIcon={<CameraAlt />}
                      onClick={() => setIsCameraOpen(true)}
                    >
                      Start Scanning
                    </Button>
                  </Box>
                </Slide>
              )}

              {isCameraOpen && (
                <Box>
                  <Box className={classes.scannerContainer} mb={2}>
                    <QrReader
                      onResult={(result, error) => {
                        if (result) {
                          handleScan(result?.text);
                        }
                      }}
                      constraints={{ facingMode: "environment" }}
                      style={{ width: "100%" }}
                    />
                    <Box className={classes.scannerOverlay}>
                      <Box className={classes.scannerFrame} />
                      {isScanning && (
                        <Box className={classes.processingOverlay}>
                          <CircularProgress size={20} color="inherit" />
                          <Typography>Processing...</Typography>
                        </Box>
                      )}
                    </Box>
                  </Box>
                  <Typography
                    variant="body2"
                    color="textSecondary"
                    align="center"
                  >
                    Position the QR code within the frame
                  </Typography>
                </Box>
              )}
            </CardContent>
          </Card>
        </Fade>

        {/* Dialog Notification */}
        <Dialog
          open={dialog.open}
          onClose={handleCloseDialog}
          TransitionComponent={Zoom}
          transitionDuration={400}
          classes={{ paper: classes.dialog }}
        >
          <DialogContent className={classes.dialogContent}>
            {/* Close IconButton at top-right */}
            <IconButton
              aria-label="close"
              onClick={handleCloseDialog}
              style={{
                position: "absolute",
                right: 16,
                top: 16,
                color: "#888",
                background: "#fff",
                zIndex: 1,
              }}
              size="small"
            >
              <Close />
            </IconButton>

            {dialog.severity === "success" && (
              <CheckCircle className={classes.successIcon} />
            )}
            {dialog.severity === "error" && (
              <Error className={classes.errorIcon} />
            )}
            {dialog.severity === "warning" && (
              <Warning className={classes.warningIcon} />
            )}
            <Typography className={classes.dialogMessage}>
              {dialog.message}
            </Typography>
            {(dialog.seatNumbers.length > 0 ||
              dialog.tripNumber ||
              dialog.tripDate) && (
              <Box>
                {dialog.seatNumbers.length > 0 && (
                  <Typography className={classes.codeText}>
                    Seat Numbers: {dialog.seatNumbers.join(", ")}
                  </Typography>
                )}
                {dialog.tripNumber && (
                  <Typography className={classes.codeText}>
                    Trip Number: {dialog.tripNumber}
                  </Typography>
                )}
                {dialog.tripDate && (
                  <Typography className={classes.codeText}>
                    Trip Date: {dialog.tripDate}
                  </Typography>
                )}
              </Box>
            )}
            {/* Add OK button here */}
            <Button
              variant="contained"
              color="primary"
              onClick={handleCloseDialog}
              style={{ marginTop: 16, minWidth: 100 }}
            >
              OK
            </Button>
          </DialogContent>
        </Dialog>
      </Container>
    </Box>
  );
};

export default QrScanner;
